import { enableProjectViewSwitcher } from '@gonfalon/dogfood-flags/dogfood-flags';
import { parseValidParams } from '@gonfalon/filters/parseValidParams';

import { defaultFlagFilter } from './internal/defaultFlagFilter';
import { parseCreationDate } from './internal/parseCreationDate';
import { parseEvaluationDate } from './internal/parseEvaluationDate';
import { parseGuardedRolloutState } from './internal/parseGuardedRolloutState';
import { parseSDKAvailability } from './internal/parseSDKAvailability';
import { parseState } from './internal/parseState';
import { parseStatusName } from './internal/parseStatusName';
import { parseType } from './internal/parseType';
import { type UIFlagFilter } from './types';

export function parseUIFlagFilterFromBrowser(searchParams: URLSearchParams) {
  const filters: UIFlagFilter = structuredClone(defaultFlagFilter);

  const validParams = parseValidParams(searchParams);

  if (validParams.has('q')) {
    filters.query = validParams.get('q') ?? undefined;
  }

  if (validParams.has('maintainerId')) {
    filters.maintainerId = validParams.get('maintainerId') ?? undefined;
  }

  if (validParams.has('maintainerTeamKey')) {
    filters.maintainerTeamKey = validParams.get('maintainerTeamKey') ?? undefined;
  }

  if (validParams.has('status')) {
    filters.status = parseStatusName(validParams.get('status'));
  }

  if (validParams.has('type')) {
    filters.type = parseType(validParams.get('type'));
  }

  if (validParams.has('sdkAvailability')) {
    filters.sdkAvailability = parseSDKAvailability(validParams.get('sdkAvailability'));
  }

  if (validParams.has('guardedRollout')) {
    filters.guardedRollout = parseGuardedRolloutState(validParams.get('guardedRollout'));
  }

  if (validParams.has('evaluated')) {
    filters.evaluated = parseEvaluationDate(validParams.get('evaluated'));
  }

  if (validParams.has('hasExperiment')) {
    filters.hasExperiment = validParams.get('hasExperiment') === 'true';
  }

  if (validParams.has('tag')) {
    filters.tags = validParams.getAll('tag').filter((tag) => tag !== '');
  }

  if (validParams.has('state')) {
    filters.state = parseState(validParams.get('state'));
  }

  if (validParams.has('created')) {
    filters.created = parseCreationDate(validParams.get('created'));
  }

  if (validParams.has('codeReferences')) {
    filters.codeReferences = validParams.get('codeReferences') === 'true';
  }

  if (validParams.has('applicationEvaluated')) {
    filters.applicationEvaluated = validParams.get('applicationEvaluated') ?? undefined;
  }

  if (validParams.has('segmentTargeted')) {
    filters.segmentTargeted = validParams.get('segmentTargeted') ?? undefined;
  }

  if (validParams.has('releasePipeline')) {
    filters.releasePipeline = validParams.get('releasePipeline') ?? undefined;
  }

  if (enableProjectViewSwitcher() && validParams.has('selected-view')) {
    filters.view = validParams.get('selected-view') ?? undefined;
  } else if (validParams.has('view')) {
    filters.view = validParams.get('view') ?? undefined;
  }

  return filters;
}
